import { ServicePriceResponseDto } from "akademika/akamont/models/ServicePriceResponseDto";
import TariffPriceTableController from "../sharedControllers/TariffPriceTableController";
import { Routes } from "akademika/akamont/constants/Routes";
import { ValueState } from "sap/ui/core/library";

/**
 * @namespace akademika.akamont.pages.servicePriceDetails
 */
export default class ServicePriceDetails extends TariffPriceTableController {
  route = Routes.SERVICE_PRICE_DETAILS;
  parentRoute = Routes.SERVICE_PRICE_LIST;

  public async onRouteMatched() {
    this.resetViewOptions();
    await this.refreshServicePriceData();
  }

  private async refreshServicePriceData() {
    const servicePrice = await this.fetchModel<ServicePriceResponseDto>(
      "api/ServicePrice/GetServicePrice/" + this.routeParams.servicePriceId,
      "servicePrice"
    );

    if (servicePrice) {
      this.setCanTariffsBeEdited(servicePrice.isEditable);
    }

    this.refreshTariffIntervalTable();
  }

  public async saveServicePrice() {
    const servicePrice =
      this.getModelData<ServicePriceResponseDto>("servicePrice");

    await this.saveDataAndShowMessage<number>(
      "api/ServicePrice/UpdateServicePrice",
      {
        body: servicePrice,
      }
    );

    this.navTo(Routes.SERVICE_PRICE_LIST);
  }

  public async addServicePrice() {
    this.navTo(Routes.SERVICE_PRICE_ADD, {
      servicePriceId: this.routeParams.servicePriceId,
    });
  }

  public async onDeleteServicePrice() {
    this.openSimpleDialog({
      title: "deleteServicePrice",
      message: "deleteServicePriceQuestion",
      state: ValueState.Warning,
      type: "Confirm",
      confirmWithComment: false,
      confirmAction: async () => {
        await this.post(
          "api/ServicePrice/DeleteServicePrice/" +
          this.routeParams.servicePriceId
        );
        this.navTo(Routes.SERVICE_PRICE_LIST);
      },
    });
  }
}
